module.exports = __webpack_public_path__ + "img/dark&box.675e88dd.jpg";